import "./CardItem.css";
import React, { useEffect, useState } from "react";
import DeleteRate from "./popups/DeleteRate";
import AddRate from "./popups/AddRate";
import axios from "../../network/axios.js";
import { hasRate } from "../../network/api/rate.js";
import { useTranslation } from "react-i18next";
import { Cookies } from "react-cookie";
import {jwtDecode} from "jwt-decode";
const cookie = new Cookies();
const CardItem = ({
  index,
  image,
  name,
  desc,
  price,
  size,
  color,
  id,
  status,
  product,
}) => {
  const [showRate, setShowRate] = useState(false);
  const [deleteRate, setdeleteRate] = useState(false);
  const [addRate, setAddRate] = useState(false);
  const [rateValue, setRateValue] = useState("");
  const [userRating, setUserRating] = useState(null);
  const [refreshing, setRefreshing] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const { t, i18n } = useTranslation();
  const token = cookie.get("user");

  const user = jwtDecode(token);
  const fetchUserRatings = async () => {
    try {
      const response = await axios.get(`/customer-reviews/user/${user?.id}`);
      if (response.data.status) {
        const userRating = response.data.data.find(
          (rating) => rating.productId._id === id.toString()
        );
        if (userRating) {
          setUserRating(userRating);
          setShowRate(true);
        }
      }
    } catch (error) {
      console.error("Error fetching user ratings:", error);
    }
  };
  useEffect(() => {
    
  
    if (token) {
      fetchUserRatings();
    }
  }, [id, token, refreshing]);

 

  const handelClosedeleteRate = () => {
    setdeleteRate(!deleteRate);
  };
  const handelCloseAddRate = () => {
    setAddRate(!addRate);
  };


  const handleUpdate = () => {
    setIsEditing(true);
    setAddRate(true);
  };
  const handleDeleteRate = async () => {
    try {
      const response = await axios.delete(`/customer-reviews/delete/user/${user?.id}/${userRating._id}`);
      if (response.data.status) {
        setRefreshing(!refreshing); // Refresh the component
        setdeleteRate(false); // Close the popup
        setUserRating(null); // Reset user rating
        setShowRate(false); // Hide the rating section
      }
    } catch (error) {
      console.error("Error deleting review:", error);
    }
  };

  const totalDiscountToday = (product?.todayDiscount || []).reduce(
    (sum, m) => sum + m.discount,
    0
  );
  const totalDiscountFlash = (product?.flashDiscount || []).reduce(
    (sum, m) => sum + m.discount,
    0
  );
  
  const hasUserRated = product?.ratingUsers?.some(
    (rating) => rating.userId.toString() === user.id.toString()
  );

  

  return (
    <>
      <DeleteRate
        show={deleteRate}
        setdeleteRate={setdeleteRate}
        onHide={handelClosedeleteRate}
        handleDeleteRate={handleDeleteRate} // Pass the delete function
      />
      <AddRate
        show={addRate}
        setAddRate={setAddRate}
        onHide={handelCloseAddRate}
        rateValue={rateValue}
        setRateValue={setRateValue}
        id={id}
        setRefreshing={setRefreshing}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
        userRating={userRating}
        fetchUserRatings={fetchUserRatings}
        // handleAddRate={handleAddRate} // Pass the add function
        // handleUpdateRate={handleUpdateRate} // Pass the update function
      />
      <div className="product" key={index}>
        <div className="info flex-grow-1 d-flex gap-4">
          <img src={image} alt="" width={58} height={70} />
          <div className="txts">
            <h2 className="">{name}</h2>
            <p className="m-0 p-0 ">{desc}</p>
            <div className="d-flex flex-column gap-2">
              <p className="m-0 p-0 d-flex align-items-center gap-2">
                <span>{product?.quantity} x</span>
                <span className="fw-bold">
                  {product?.price - totalDiscountToday - totalDiscountFlash}
                </span>
              </p>
              <div className="d-flex align-items-center gap-1">
                <span className="fw-bold text-primary">{t("curency")}</span>
                <span className="fw-bold">
                  {product?.quantity *
                    (product?.price - totalDiscountToday - totalDiscountFlash)}
                </span>
              </div>
            </div>
            <div className="size-clr d-flex gap-3">
              <div className="size">
                <span>مقاس:</span> {size}
              </div>
              <div className="d-flex align-items-center gap-1">
                <div>اللون:</div>{" "}
                <div
                  style={{
                    backgroundColor: color,
                    width: "50px",
                    height: "50px",
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
        {showRate ? (
          <div className="rate">
            <p>تعليقك</p>
            <div className="value">
              <div className="num d-flex align-items-center gap-1">
                <p className="m-0">{userRating?.rate} من 5</p>
                <div className="d-flex">
                  {[...Array(userRating?.rate)].map((_, index) => (
                    <svg
                      key={index}
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.30992 13.4081L12.8537 15.6581C13.3107 15.9464 13.8732 15.5175 13.7396 14.9902L12.713 10.9542C12.6853 10.8423 12.6897 10.7249 12.7258 10.6154C12.7619 10.506 12.8281 10.4089 12.917 10.3355L16.0951 7.68469C16.5099 7.34015 16.299 6.64406 15.7576 6.6089L11.6091 6.34172C11.496 6.33513 11.3871 6.29572 11.296 6.22829C11.2048 6.16086 11.1353 6.06834 11.0959 5.96203L9.54898 2.06672C9.50804 1.95415 9.43344 1.85691 9.33533 1.78819C9.23721 1.71948 9.12033 1.68262 9.00055 1.68262C8.88076 1.68262 8.76388 1.71948 8.66576 1.78819C8.56765 1.85691 8.49306 1.95415 8.45211 2.06672L6.90523 5.96203C6.86581 6.06834 6.79627 6.16086 6.70512 6.22829C6.61397 6.29572 6.50514 6.33513 6.39195 6.34172L2.24352 6.6089C1.70211 6.64406 1.49117 7.34015 1.90602 7.68469L5.08414 10.3355C5.17297 10.4089 5.23924 10.506 5.27532 10.6154C5.31139 10.7249 5.3158 10.8423 5.28805 10.9542L4.33883 14.6948C4.17711 15.3277 4.85211 15.8409 5.39352 15.4964L8.69117 13.4081C8.78365 13.3493 8.89096 13.3181 9.00055 13.3181C9.11013 13.3181 9.21745 13.3493 9.30992 13.4081Z"
                        fill="url(#paint0_linear_1606_9215)"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_1606_9215"
                          x1="9.00055"
                          y1="1.68262"
                          x2="9.00055"
                          y2="15.7509"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#FACE32" />
                          <stop offset="1" stop-color="#FA8232" />
                        </linearGradient>
                      </defs>
                    </svg>
                  ))}
                </div>
              </div>
          
              
              <p className="txt mb-1">{userRating?.content}</p>
            </div>
            <div className="d-flex justify-content-end gap-2 mt-2">
              <button onClick={() => setdeleteRate(true)}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.33073 8.12533C8.79097 8.12533 9.16406 8.49842 9.16406 8.95866V13.9587C9.16406 14.4189 8.79097 14.792 8.33073 14.792C7.87049 14.792 7.4974 14.4189 7.4974 13.9587V8.95866C7.4974 8.49842 7.87049 8.12533 8.33073 8.12533Z"
                    fill="#667085"
                  />
                  <path
                    d="M12.4974 8.95866C12.4974 8.49842 12.1243 8.12533 11.6641 8.12533C11.2038 8.12533 10.8307 8.49842 10.8307 8.95866V13.9587C10.8307 14.4189 11.2038 14.792 11.6641 14.792C12.1243 14.792 12.4974 14.4189 12.4974 13.9587V8.95866Z"
                    fill="#667085"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14.9974 5.00033V4.16699C14.9974 2.78628 13.8781 1.66699 12.4974 1.66699H7.4974C6.11668 1.66699 4.9974 2.78628 4.9974 4.16699V5.00033H3.7474C3.28716 5.00033 2.91406 5.37342 2.91406 5.83366C2.91406 6.2939 3.28716 6.66699 3.7474 6.66699H4.16406V15.8337C4.16406 17.2144 5.28335 18.3337 6.66406 18.3337H13.3307C14.7114 18.3337 15.8307 17.2144 15.8307 15.8337V6.66699H16.2474C16.7076 6.66699 17.0807 6.2939 17.0807 5.83366C17.0807 5.37342 16.7076 5.00033 16.2474 5.00033H14.9974ZM12.4974 3.33366H7.4974C7.03716 3.33366 6.66406 3.70676 6.66406 4.16699V5.00033H13.3307V4.16699C13.3307 3.70676 12.9576 3.33366 12.4974 3.33366ZM14.1641 6.66699H5.83073V15.8337C5.83073 16.2939 6.20383 16.667 6.66406 16.667H13.3307C13.791 16.667 14.1641 16.2939 14.1641 15.8337V6.66699Z"
                    fill="#667085"
                  />
                </svg>
              </button>
              <button onClick={handleUpdate}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17.3018 6.81991C18.2781 5.8436 18.2781 4.26069 17.3018 3.28438L16.7125 2.69512C15.7362 1.71881 14.1533 1.71881 13.177 2.69512L3.68804 12.1841C3.34331 12.5288 3.10689 12.9668 3.00789 13.4442L2.33818 16.6735C2.21639 17.2607 2.73613 17.7805 3.32336 17.6587L6.55272 16.989C7.03009 16.89 7.4681 16.6536 7.81284 16.3089L17.3018 6.81991ZM16.1233 4.46289L15.534 3.87363C15.2086 3.5482 14.6809 3.5482 14.3555 3.87363L13.4716 4.75755L15.2394 6.52531L16.1233 5.6414C16.4487 5.31596 16.4487 4.78833 16.1233 4.46289ZM14.0608 7.70382L12.2931 5.93606L4.86655 13.3626C4.75164 13.4775 4.67284 13.6235 4.63984 13.7826L4.22789 15.769L6.21428 15.3571C6.37341 15.3241 6.51941 15.2453 6.63433 15.1303L14.0608 7.70382Z"
                    fill="#667085"
                  />
                </svg>
              </button>
            </div>
          </div>
        ) : (
          status === "delivered" &&
          !hasUserRated && (
            <div
              style={{ cursor: "pointer" }}
              className="d-flex align-items-center gap-2 add-str cursor-pointer"
              onClick={() => handelCloseAddRate()}
            >
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.16667 4.16667H5.83333V0.833333C5.83333 0.61232 5.74554 0.400358 5.58926 0.244078C5.43297 0.0877975 5.22101 0 5 0C4.77899 0 4.56702 0.0877975 4.41074 0.244078C4.25446 0.400358 4.16667 0.61232 4.16667 0.833333V4.16667H0.833333C0.61232 4.16667 0.400358 4.25446 0.244078 4.41074C0.0877975 4.56702 0 4.77899 0 5C0 5.22101 0.0877975 5.43297 0.244078 5.58926C0.400358 5.74554 0.61232 5.83333 0.833333 5.83333H4.16667V9.16667C4.16667 9.38768 4.25446 9.59964 4.41074 9.75592C4.56702 9.9122 4.77899 10 5 10C5.22101 10 5.43297 9.9122 5.58926 9.75592C5.74554 9.59964 5.83333 9.38768 5.83333 9.16667V5.83333H9.16667C9.38768 5.83333 9.59964 5.74554 9.75592 5.58926C9.9122 5.43297 10 5.22101 10 5C10 4.77899 9.9122 4.56702 9.75592 4.41074C9.59964 4.25446 9.38768 4.16667 9.16667 4.16667Z"
                  fill="#C99700"
                />
              </svg>
              <span>اضف تقييم</span>
            </div>
          )
        )}
      </div>
    </>
  );
};

export default CardItem;
